export class AppEndPointModel{
    FieldServiceEndpointPrefix:string;
    PaymentProcessorCardConnectEndPoint:string;
    QuickBookOnlineEndPoint:string;
    InventoryManagementEndPoint:string;
    ReportServiceUrl:string;
    GoogleMapAPIKey:string;
    ExtractorEndpointPrefix:string;
    ExtractorStorageUrl:string;
    constructor(){   
        this.FieldServiceEndpointPrefix = "",
        this.PaymentProcessorCardConnectEndPoint = "",
        this.QuickBookOnlineEndPoint = "",
        this.InventoryManagementEndPoint = "",
        this.ReportServiceUrl = "",
        this.GoogleMapAPIKey = "",
        this.ExtractorEndpointPrefix = "",
        this.ExtractorStorageUrl = ""
    }
}